import { useState } from "react";
import { AuthStoreInterface, AuthStoreKey, AuthUserInterface } from "../model/auth.types";
import { UserRole } from "@/shared/model/constants";

export const useAuthStore = ():AuthStoreInterface => {
  const [loading, updateLoadingState] = useState<Record<AuthStoreKey, boolean>>({
    login: false,
    logout: false,
    refresh: false
  });
 
  const [error, updateErrorState] = useState<Record<AuthStoreKey, string | null>>({
    login: null,
    logout: null,
    refresh: null
  });

  const setLoadingState = (key: AuthStoreKey, value: boolean) => {
    updateLoadingState(prev => ({ ...prev, [key]: value }));
  };

  const setErrorState = (key: AuthStoreKey, value: string | null) => {
    updateErrorState(prev => ({ ...prev, [key]: value }));
  };

  const [isAuth, setIsAuth] = useState(false)
  const [isHead, setIsHead] = useState(false)
  const [user, setUser] = useState<AuthUserInterface | null>(null)
  const [userRole, setUserRole] = useState<UserRole | null>(null)
  const [pinUnlocked, setPinUnlocked] = useState(false)
  
  return {
    loading,
    setLoadingState,
    error,
    setErrorState,
    isAuth, setIsAuth,
    isHead, setIsHead,
    user, setUser,
    userRole, setUserRole,
    pinUnlocked, setPinUnlocked
  }
}
